import React from "react";
import { useSelector } from "react-redux";
import FormalityHeader from "../../components/header/FormalityHeader";
import PasswordlessLogin from "../../components/auth/PasswordlessLogin";

function FormalityLogin() {
  const cart = useSelector((state) => state.cart);

  return (
    <PasswordlessLogin
      header={<FormalityHeader from={cart.from} />}
      otpPath="/formality-otp"
      signupPath="/formality-user-information"
    />
  );
}

export default FormalityLogin;
